import { render, staticRenderFns } from "./VisioDeactivation.vue?vue&type=template&id=21ab287d"
import script from "./VisioDeactivation.vue?vue&type=script&lang=ts"
export * from "./VisioDeactivation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports